import { Route } from 'react-router-dom';
import ClientRequestsPage from './pages/ClientRequestsPage';

// «Mis peticiones» (F2 del sistema de peticiones, 11-oct-2026): entrada propia del menú, sin gate de
// módulo ni de plan — cualquier usuario del negocio puede pedir/contestar (el backend filtra por tenant).
export const ClientRequestsRoutes = [
  <Route key="peticiones" path="/dashboard/peticiones" element={<ClientRequestsPage />} />,
];
